const state = {
  modal: [],
}

const getters = {
  activeModal: (state) => {
    return state.modal.length > 0 ? state.modal[0] : null
  },

  allModals: (state) => state.modal,
}

const actions = {
  openModal: ({ commit }, modal) => commit('openModal', modal),
  closeModal: ({ commit }, modal) => commit('closeModal', modal),
}

const mutations = {
  openModal: (state, modal) => state.modal.unshift(modal),

  closeModal: (state, modal) => {
    state.modal = state.modal.filter((item) => {
      item !== modal
    })
  },

  closeAllModals: (state) => {
    state.modal = []
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
